export const notificationMessage = {
    invalidCode: 'Nieprawidłowy kod weryfikacyjny. Spróbuj ponownie.',
    resendCodeSuccess: 'Kod został wysłany ponownie. Sprawdź swoją skrzynkę oraz folder spam.',
    newPasswordSuccess: 'Nowe hasło zostało ustawione pomyślnie. Możesz się zalogować.',
    tooManyAttempts: 'Zbyt wiele próśb zresetowania hasła. Spróbuj ponownie później.',
};
